import { SVGProps } from 'react';

const AirshipIcon: React.FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 200 200"
    {...props}
  >
    <style>{`.cls-1{fill:#be1624;stroke-width:0px;}`}</style>
    <path
      className="cls-1"
      d="M96.24,87.24l-16.32,35.7-4.58,10.35c6.37,2.9,13.44,4.52,20.9,4.52s14.01-1.51,20.2-4.21l-4.62-10.66-15.57-35.7Z"
    />
    <path
      className="cls-1"
      d="M129.54,125.28c10.58-9.27,17.27-22.87,17.27-38.04,0-27.93-22.64-50.58-50.58-50.58s-50.58,22.64-50.58,50.58c0,14.95,6.49,28.38,16.8,37.64l34.05-73.14,33.03,73.54Z"
    />
    <path
      className="cls-1"
      d="M116.44,133.6l1.84,4.23,11.02,25.5h17.34l-17.09-38.06c-3.89,3.41-8.3,6.23-13.1,8.32Z"
    />
    <path
      className="cls-1"
      d="M44.55,163.34h17.07l11.7-25.5,2.01-4.55c-4.72-2.15-9.06-4.99-12.87-8.41l-17.91,38.46Z"
    />
  </svg>
);

export default AirshipIcon;
